// * Types functions as an enum for the different actions to be applied in each context.

export const SIGNIN = 'SIGNIN';
export const SIGNOUT = 'SIGNOUT';
export const SELECT_INSTITUTION = 'SELECT_INSTITUTION';
export const UPDATE_FIRST_TIME = 'UPDATE_FIRST_TIME';

